export default __webpack_public_path__ + "static/media/response_alert.30e86c83.svg";